import React from 'react';
import arrowIcon from '../assets/arrow.svg';
import doubleArrowIcon from '../assets/double-arrow.svg';
const arrow = { path: arrowIcon };
const doubleArrow = { path: doubleArrowIcon };

const Pagination = (params: any) => {
    return (
        <div className="flex items-center justify-center w-full py-3">
            <button
                className="bg-transparent"
                onClick={params.firstPage}
                disabled={params.currentPage === 1}
            >
                <img
                    src={doubleArrow.path}
                    alt="double arrow icon"
                    className="w-[19px] h-[19px] mr-2"
                />
            </button>
            <button
                className="bg-transparent"
                onClick={params.previous}
                disabled={params.currentPage === 1}
            >
                <img src={arrow.path} alt="arrow icon" className="w-[19px] h-[19px] mr-2" />
            </button>
            <span className="bg-white rounded-3xl py-3 px-3 text-base font-semibold text-gray-800">
                {params.currentPage} / {params.totalPage}
            </span>
            <button
                className="bg-transparent"
                onClick={params.next}
                disabled={params.currentPage === params.totalPage}
            >
                <img
                    src={arrow.path}
                    alt="arrow icon"
                    className="w-[19px] h-[19px] ml-2 rotate-180"
                />
            </button>
            <button
                className="bg-transparent"
                onClick={params.lastPage}
                disabled={params.currentPage === params.totalPages}
            >
                <img
                    src={doubleArrow.path}
                    alt="double arrow icon"
                    className="w-[19px] h-[19px] ml-2 rotate-180"
                />
            </button>
        </div>
    );
};

export default Pagination;
